export type BinderSubmissionStatus = 'processing' | 'failed' | 'ready' | 'confirmed' | 'discarded';

export interface ExternalPolicyBinderSubmission {
  submissionId: number;
  accountId: number;
  documentId: string;
  documentName: string;
  invocationId: string;
  status: BinderSubmissionStatus;
  errorMessage?: string;
  promptResultId?: number;
  createdPolicyIds?: number[];
  submittedBy: string;
  submittedAt: string;
  resolvedAt?: string;
}

export interface ConfirmBinderResponse {
  validPolicy: boolean;
  messages: string[];
  createdPolicyIds?: number[];
}

export const MAX_BINDER_SIZE_BYTES = 25 * 1024 * 1024;

// One selectable reference value and the group it rolls up to. A policy line stores the
// child entity, so the group travels with the option instead of being a second thing to pick.
export interface ExternalPolicyEntityOption {
  name: string;
  groupName: string;
}

// Reference values a reviewer may pick from when correcting what an extraction resolved.
export interface ExternalPolicyEntityOptions {
  issuingCompanies: ExternalPolicyEntityOption[];
  coverageTypes: string[];
  wholesalers: ExternalPolicyEntityOption[];
}
